<template>
  <template v-if="isShow">
    <slot />
  </template>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  auth: {
    type: String,
    required: false,
    default: undefined
  }
})

// 所有权限列表
const isShow = computed(() => {
  return mm.store.state.authList.find(v => {
    return v.key === props.auth
  })
})
</script>
